import React from 'react';
import { Divider, Popconfirm, Tooltip, Icon } from 'antd';

export default (self, s) => [
  {
    title: '机构名称',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: '负责人',
    dataIndex: 'principal',
    key: 'principal',
    width: 120,
  },
  {
    title: '层级',
    dataIndex: 'org_level',
    key: 'org_level',
    width: 60,
  },
  {
    title: '上级机构',
    dataIndex: 'parent_org_name',
    key: 'parent_org_name',
  },
  {
    title: '共享',
    dataIndex: 'share_to_orgs_name',
    key: 'share_to_orgs_name',
    render: (t = []) => t.join(' | '),
  },
  {
    title: '机器人地址',
    dataIndex: 'client_ui_url',
    key: 'client_ui_url',
    width: 50,
    render: t => (
      <Tooltip
        title={
          <a className={s.tipLink} href={t} target="_blank">
            {t}
          </a>
        }
      >
        <Icon type="link" style={{ cursor: 'pointer' }} />
      </Tooltip>
    ),
  },
  {
    title: '备注',
    dataIndex: 'remark',
    key: 'remark',
  },
  {
    title: '操作',
    dataIndex: 'x',
    key: 'x',
    width: 200,
    render: (t, item) => (
      <div>
        <a
          onClick={() => {
            self.setModals({
              key: 'updateForm',
              title: '添加子机构',
              item: {
                parent_org: item.id,
              },
              visible: true,
            });
          }}
        >
          添加子机构
        </a>
        <Divider type="vertical" />
        <a
          onClick={() => {
            self.setModals(
              {
                key: 'updateForm',
                title: '编辑机构',
                item,
                visible: true,
              },
              false,
            );
          }}
        >
          编辑
        </a>
        <Divider type="vertical" />
        <Popconfirm
          title="删除后不可恢复，确认删除吗？"
          placement="left"
          okText="确认"
          cancelText="取消"
          onConfirm={() => self.deleteItem(item.id)}
        >
          <a>删除</a>
        </Popconfirm>
      </div>
    ),
  },
];
